import shoppingContext from 'api/definitions/shoppingContext';
import { shoppingContextActionTypes } from './types';

export const getShoppingContext = () => ({
  types: shoppingContextActionTypes.triplet,
  apiCall: shoppingContext.get(),
});
